import { useAppSearchParams } from '@/hooks/use-app-search-params';
import { cn } from '@/lib/utils';
import type { Workspace } from '@/services/types';

type Props = {
  data: Workspace | undefined;
};
const LeftSide = (props: Props) => {
  const { data } = props;
  const color = data?.color ?? '#070D27';
  const params = useAppSearchParams();
  const view = params.get('view');

  const items = [
    {
      name: 'Company Information',
      key: 'company-info'
    },
    {
      name: 'Contact Information',
      key: 'contact-info'
    },
    {
      name: 'Expertise And Niche Information',
      key: 'expertise'
    },
    {
      name: 'Media Upload',
      key: 'media'
    },
    {
      name: 'Projects',
      key: 'projects'
    },
    {
      name: 'Experience',
      key: 'experience'
    }
  ];
  return (
    <div
      className={cn('flex w-full flex-col p-6 text-white md:w-[580px] md:p-10')}
      style={{ background: color }}
    >
      <div className='relative'>
        <img
          src={'/icons/new-logo.svg'}
          alt={`${data?.name}-logo`}
          className='h-10'
          // fill
          // className='h-20'
        />
      </div>

      <div className='my-8'>
        <h2 className='mb-2 text-2xl font-bold'>Welcome Aboard!</h2>
        <p className='text-sm text-gray-400'>
          You have been invited to join the {data?.name} Stakeholder
          Map. Please follow the steps below to get started.
        </p>
      </div>

      <div className='flex-grow'>
        <nav className='space-y-4 border-l-2 border-[#3a4d99]'>
          {items.map((item) => (
            <div
              key={item.key}
              className='flex h-10 cursor-pointer items-center gap-4 font-medium transition-colors hover:text-gray-300'
              onClick={() => params.set({ view: item.key })}
            >
              {
                <div
                  className={cn('h-full w-1', view === item.key && 'bg-white')}
                />
              }
              {item.name}
            </div>
          ))}
        </nav>
      </div>

      <div className='mt-auto pt-6 text-sm'>www.policyvault.africa</div>
    </div>
  );
};

export default LeftSide;
